export default __webpack_public_path__ + "static/media/billing.9b4e1fa5.png";